import { ApptSubModel } from "./appt-sub.model"

export class ApptModel {
    client_no: number
    appointment_id: number
    sub_appt_id: number
    pet_name: string
    appointment_date: string
    appointment_time: string
    dropoff_time: string
    dropoff: boolean
    doctor: string
    doctor_name: string
    appt_fulfill: string
    appointment_note: string

    dropoff_time_needed: string
    pickup_date: string
    pickup_time: string
    pickup_time_needed: string
    doctor_start_time: string
    private _doctor_time_needed: string

    set doctor_time_needed(value: string) {
        this._doctor_time_needed = value;
    }

    get doctor_time_needed(): string {
        let time = '';

        if (this.appt_sub && this.appt_sub.length > 0) {
            let suma = 0;
            this.appt_sub.forEach(element => {                
                suma += Number(element.dtime);
            });
            time = suma.toString();
        }

        return time;
    }

    room: string
    room_start_time: string
    room_time_needed: string
    made_by: string
    modified_by: string
    create_date: string

    appt_sub: ApptSubModel[]

    constructor(
        client_no: number,
        appointment_id: number,
        sub_appt_id: number,
        pet_name: string,
        appointment_date: string,
        dropoff_time: string,
        doctor: string,
        doctor_name: string,
        appt_fulfill: string,
        appointment_note: string,
        dropoff: boolean
    ) {
        this.client_no = client_no
        this.appointment_id = appointment_id
        this.sub_appt_id = sub_appt_id
        this.pet_name = pet_name
        this.appointment_date = appointment_date
        this.dropoff_time = dropoff_time
        this.doctor = doctor
        this.doctor_name = doctor_name
        this.appt_fulfill = appt_fulfill
        this.appointment_note = appointment_note
        this.dropoff = dropoff
    }
}


export class FutureApptsModel {
    appointment_date: string
    dropoff_time: string
    pet_name: string
    appointment_id: number
    appt_proc_name: string

    constructor(
        appointment_date: string,
        dropoff_time: string,
        pet_name: string,
        appointment_id: number,
        appt_proc_name: string
    ) {
        this.appointment_date = appointment_date
        this.dropoff_time = dropoff_time
        this.pet_name = pet_name
        this.appointment_id = appointment_id
        this.appt_proc_name = appt_proc_name
    }
}   